import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PersonnalInfoForm from './personnal-info-form';
import BillingInfoForm from './billing-info-form';
import Button from '../Buttons/button';
import ExplanationStep from '../explanation-step';
import Hr from '../Style/hr';
import ButtonSecondary from '../Buttons/button-secondary';
import { validateCustomerAndBillingFormData } from '../../services/validator.service';
import { submitFormData } from '../../services/api.service';
import { useSubdomain } from '../../contexts/subdomain';
import _ from 'lodash';

export default function PersonnalAndAddressForm({ returnedData, initialFormData = {} }) {
    const { t } = useTranslation();
    const { subdomain } = useSubdomain();

    const [customer, setCustomer] = useState({
        email: '',
        lastname: '',
        firstname: '',
        phone: '',
        ...initialFormData.customer
    });

    const [billing, setBilling] = useState({
        address: '',
        address2: '',
        city: '',
        postalCode: '',
        country: '',
        VATNumber: '',
        companyName: '',
        ...initialFormData.billing
    });

    const services = initialFormData.services || [];

    const [errors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        setIsSubmitting(true);

        const errors = validateCustomerAndBillingFormData(customer, billing, t);
        setFormErrors(errors);

        if (Object.keys(errors).length > 0) return setIsSubmitting(false);

        try {
            const response = await submitFormData(_.get(initialFormData, '_id', null), customer, billing, services, subdomain, t);
            const res = response.data;

            if (res.status) {
                returnedData({ step: "step3", _id: res.data._id, customer, billing });

            } else {
                console.error("API error:", res);
            }
        } catch (error) {
            console.error("Submit error:", error);
        } finally {
            setIsSubmitting(false);
        }
        returnedData({
            step: 'step3',
            customer,
            billing
        });
    };

    return (
        <div className='px-4 md:px-0'>
            <div className="flex flex-col gap-4 md:gap-6">
                <div className='flex flex-col md:flex-row gap-5 md:gap-40'>
                    <div className="w-full md:w-64 flex flex-col gap-5">
                        <ExplanationStep
                            title={t('pageServices.step2.personalInformation')}
                            description={t('pageServices.step2.personalInformationDescription')}
                        />
                    </div>

                    <div className="flex flex-col w-full">
                        <PersonnalInfoForm
                            customer={customer}
                            errors={errors}
                            updatePersonnalInfoFormData={setCustomer}
                        />
                    </div>
                </div>
                <Hr />
                <div className='flex flex-col md:flex-row gap-5 md:gap-40'>
                    <div className="w-full md:w-64 flex flex-col gap-5">
                        <ExplanationStep
                            title={t('pageServices.step2.billingInformation')}
                            description={t('pageServices.step2.billingInformationDescription')}
                        />
                    </div>

                    <div className="flex flex-col w-full">
                        <BillingInfoForm
                            data={billing}
                            errors={errors}
                            updateBillingInfoFormData={setBilling}
                        />
                    </div>
                </div>
            </div>

            <Hr />

            <div className="flex flex-col-reverse md:flex-row md:justify-between gap-5 my-10 ">
                <ButtonSecondary text={t('inputs.back')} disabled={isSubmitting} onClick={() => returnedData({ step: 'step1' })} />
                <Button text={t('inputs.nextStep')} disabled={isSubmitting} onClick={handleSubmit} />
            </div>
        </div>
    )
}